import { useAuth } from '@/state/auth';

/**
 * Returns the tenant whose data is currently being viewed — matches the value
 * the backend uses for `aws.Username`. When impersonating, this is the friend's
 * email; otherwise it's the caller's own email. `displayName` prefers the
 * server-provided display name, falling back to the email.
 */
export function useViewedTenant(): { email: string; displayName: string } {
  const { me, friend, whoami } = useAuth();
  const email = friend || me;
  const displayName = whoami?.tenant?.display_name || email;
  return { email, displayName };
}
